import { LuInfo } from "react-icons/lu";

import { useTranslator } from "@eo-locale/react";

import { Box, HTMLWrapper, useToast } from "@/storybook-components";

import { setUnverifiedModalOpen } from "@/redux/features/unverified-modal/slice";

import { useAppDispatch, useAppSelector } from "@/redux/store/hooks";
import useUser from "../useUser";

const useShowUnverifiedModal = ({
  isNewPin = false
}: {
  isNewPin?: boolean;
}) => {
  const unverifiedToastId = "unverified-user-toast";
  const project = useAppSelector((state) => state.project.project);
  const places = useAppSelector((state) => state.place.place);
  const getRoute = (route: "login" | "register") => {
    return `/${route}?next=${encodeURIComponent(`/${project.permalink}/places/${places.permalink}`)}`;
  };
  const { translate } = useTranslator();

  const dispatch = useAppDispatch();

  const { allowUnverifiedParticipation } = useAppSelector(
    (state) => state.place.place
  );

  const { isRegisteredUserLoggedIn, isUnverfiedUserLoggedIn } = useUser();

  const toast = useToast();

  // if the user is not logged in and unverified participation is not allowed
  const showModal = !isRegisteredUserLoggedIn && !allowUnverifiedParticipation;

  const showUnverifiedModal = () => {
    if (showModal) {
      if (!toast.isActive(unverifiedToastId)) {
        toast({
          title: translate("brainstormers.unverifiedDisabledToastTitle"),
          duration: 2000,
          icon: <LuInfo fontSize="1.25rem" />,
          position: "bottom",
          id: unverifiedToastId,
          isClosable: true,
          description: (
            <Box mt={2} fontSize="0.875rem">
              <HTMLWrapper
                className="create-idea-form"
                html={translate(
                  "brainstormers.unverifiedDisabledToastDescription",
                  {
                    loginRoute: getRoute("login"),
                    registerRoute: getRoute("register")
                  }
                )}
              />
            </Box>
          ),
          status: "info"
        });
      }
      return true;
    }

    // if the user is not logged in and not verified
    if (!isRegisteredUserLoggedIn && !isUnverfiedUserLoggedIn && isNewPin) {
      dispatch(setUnverifiedModalOpen(true));

      return true;
    }

    return false;
  };
  return { showUnverifiedModal };
};

export default useShowUnverifiedModal;
